import { Component, ChangeDetectionStrategy, DestroyRef, OnInit, inject } from "@angular/core";
import { MatCardModule } from "@angular/material/card";
import { MatTabsModule } from "@angular/material/tabs";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "privacy-policy",
  imports: [
    ...SHARED_IMPORTS,
    MatCardModule,
    MatTabsModule,
    RouterModule,
  ],
  templateUrl: "./privacy-policy.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivacyPolicyComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly route = inject(ActivatedRoute);

  selectedTabIndex = 0;

  ngOnInit(): void {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      const tabParam = params["tab"];
      if (tabParam === "user") {
        this.selectedTabIndex = 0;
      } else if (tabParam === "staff") {
        this.selectedTabIndex = 1;
      } else {
        this.selectedTabIndex = 0;
      }
    });
  }
}
